import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../CSS/style.css";
import axios from "axios";
import strings from "../String";

const ScheduleA = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let checkTheme = document.getElementById("root");
    if (checkTheme.classList.contains("dark-mode")) {
      checkTheme.classList.remove("dark-mode");
    }
  });
  // useEffect(() => {
  //   // Load remembered email from local storage
  //   const themeColor = localStorage.getItem('themeColor');
  //   console.log("Inside Dark Mode")
  //   //const rememberedPassword=localStorage.getItem('rememberedPassword');
  //   if (themeColor==='light_mode') {
  //     console.log("Inside Dark Mode")
  //     document.body.classList.add('dark-mode');
  //   }
  //   else{
  //     document.body.classList.remove('dark-mode');
  //   }
  // }, []);
  return (
    <section class="bg-white ">
      <div class="container eulaDocMain">
        <div class="row headerLogo">
          <div class="col">
          <div class="eulaDocCopilotDiv" id="chat-header">
              <img
                src="Img/cimatron-logo-720x177.png"
                alt="Cimatron-logo"
                className="img-fluid d-block eulaDocLogo"
              /> <div class="vr"></div> <img
                src="Img/copilot-icon-text-bubble-black-512.png"
                alt="copilot-icon-text-bubble-white"
                className="eulaDocCopilot-icon" id="copilot-icon"
              /> <h3 class="px-2">Cimatron Copilot</h3>
            </div>
          </div>
        </div>
        <div class="row eula-content">
          <div class="col">
            <div class="pb-2">
              <h1>Schedule A to End-User License Agreement </h1>
              <hr />
            </div>
            <div class="pb-2">
              <h3>TERMS OF USE REGARDING CIMATRON AI COPILOT</h3>
              <h4>
                1. LIMITED LICENSE TO USE CIMATRON AI COPILOT FOR USERS THAT
                HAVE BEEN GRANTED ACCESS TO CIMATRON AI COPILOT{" "}
              </h4>
              <p>
                Subject to the terms and conditions of this Schedule A and the
                relevant terms of the <a href="/end-user-license-agreement">End-User License Agreement (“EULA”)</a> of
                CIMATRON (Schedule A prevails in the event of conflict),
                CIMATRON grants You a non-exclusive, non-transferable,
                non-sublicensable, revocable, limited license to use the AI
                chatbot feature “CIMATRON AI COPILOT” solely in conjunction with
                the licensed SOFTWARE for Your internal business purposes and
                subject to that you have an active license [and maintenance
                contract] regarding the licensed SOFTWARE and have accepted the
                latest version of the EULA and this Schedule A, as updated from
                time to time by CIMATRON.
              </p>
              <p>
                You acknowledge that CIMATRON AI COPILOT is a cloud based AI
                feature that is [still considered as a BETA software ] under
                continuous development and that CIMATRON AI COPILOT is provided
                "as is" and that it may give inaccurate, incomplete answers or
                answers including errors. You agree to use CIMATRON AI COPILOT
                at Your own risk and discretion, and to comply with all
                applicable laws and regulations when using CIMATRON AI COPILOT.
              </p>
              <p>
                CIMATRON may at any time implement and enforce limitations on
                the number of questions that can be made to CIMATRON AI COPILOT.
                You agree to abide by any such rate limiting and access
                restrictions as communicated by CIMATRON.
              </p>
              <p>
                CIMATRON and its affiliates reserve the right to modify,
                suspend, or terminate CIMATRON AI COPILOT at any time without
                notice or liability to You. Upon termination/expiration the
                provisions that are intended by their nature to survive
                termination will survive and continue to be in full force and
                effect in accordance with their terms, including confidentiality
                obligations, limitation of liability and disclaimers.
              </p>
              <p>
                You will not and will not permit Your users to:
                <ol type="i" class="braceswithi">
                  <li>
                    use CIMATRON AI COPILOT for any other purpose than the
                    purpose of asking questions and seek guidelines regarding
                    technical usage of the licensed SOFTWARE (the “Purpose”);{" "}
                  </li>
                  <li>
                    use CIMATRON AI COPILOT in any manner that violates any
                    applicable law, regulation, third-party right, any policy,
                    instruction or guideline issued in relation to CIMATRON AI
                    COPILOT from time to time (“CIMATRON AI COPILOT POLICY ”);
                  </li>
                  <li>
                    modify, copy, distribute, or reverse engineer CIMATRON AI
                    COPILOT or its underlying technology;{" "}
                  </li>
                  <li>
                    utilize any data extracting techniques, such as data
                    scraping, to access CIMATRON AI COPILOT in a manner that
                    sends more requests to the servers than a human can
                    reasonably produce in the same period of time using a
                    conventional online web browser;{" "}
                  </li>
                  <li>
                    use CIMATRON AI COPILOT in a manner that infringes,
                    misappropriates, or otherwise violates any third party’s
                    rights;{" "}
                  </li>
                  <li>
                    enter any personal data in the free text fields available
                    for Prompts (as defined below).
                  </li>
                </ol>
              </p>
              <h4>
                2. INPUTS/PROMPTS, PROCESSING OF USER DATA AND PERSONAL DATA
              </h4>
              <hr />
              <p>
                You and Your users may provide input/prompts to CIMATRON AI
                COPILOT (“Prompts”). You retain the ownership and intellectual
                property rights to any input data/information that is owned by
                You and provided by You and Your users in CIMATRON AI COPILOT as
                Prompts. You agree not to provide any proprietary or
                confidential data to CIMATRON AI COPILOT when inserting Your
                Prompts. You are solely responsible for the quality of Prompts
                and You represent and warrant that You are the owner of or have
                the appropriate right, license or permission to provide the
                Prompts that You and Your users enter into CIMATRON AI COPILOT
                and does not infringe the right of any third party when entering
                Prompts. You represent and warrant that You will use CIMATRON AI
                COPILOT in accordance with applicable laws and regulations and
                any CIMATRON AI COPILOT POLICY and only for the Purpose. You
                understand that CIMATRON AI COPILOT is, except for the personal
                data necessary for login and registration with CIMATRON AI
                COPILOT, not meant to process any Prompts including personal
                data and You agree to not enter any personal data in the free
                text fields available for Prompts. You agree to indemnify,
                defend, and hold harmless CIMATRON and its Affiliates from any
                claims, damages, losses, or costs arising from Your violation of
                this section.
              </p>
              <p>
                CIMATRON will not disclose Prompts and feedback data (“User
                Data”) that includes information that is identified as
                confidential by You or should be reasonably understood to be
                confidential under the circumstances (“Confidential
                Information”) with other customers/users or third parties
                unrelated to CIMATRON, its affiliates and suppliers unless it is
                deemed necessary by CIMATRON to comply with applicable law or to
                enforce any CIMATRON AI COPILOT POLICY or the User Data is
                anonymized or necessary to disclose to distribute, service,
                support or further develop CIMATRON AI COPILOT in accordance
                with what is further specified below. For the avoidance of
                doubt, the obligation to maintain confidentiality of
                Confidential Information in this section does not apply to
                information that (i) is or becomes generally available to the
                public through no fault of CIMATRON (iii) was in CIMATRON’S or
                its affiliates or suppliers possession or known by CIMATRON or
                its affiliates or suppliers prior to receipt (iv) was rightfully
                disclosed to CIMATRON or its affiliates or suppliers without
                restriction from a third party (v) was independently developed
                by or otherwise belongs to CIMATRON or any of its suppliers and
                affiliates.
              </p>
              <p>
                You specifically acknowledge and agree that CIMATRON AI COPILOT
                collects, store, process, use, transmit, and disclose User Data
                in accordance with the following:
              </p>
              <ul class="pb-3">
                <li>
                  CIMATRON and its affiliates and suppliers record and reserve
                  the right to use User Data for the purposes of (i) delivery of
                  and providing customer support and service relating to
                  CIMATRON AI COPILOT and (ii) for purposes of general product
                  development, quality assurance and improvement of products and
                  services. User Data may and will be shared with affiliates and
                  suppliers for these purposes. Please refer to the Transparency
                  Note, as updated from time to time, for additional
                  information.
                </li>
                <li>
                  CIMATRON AI COPILOT is based on and build with a third party
                  cloud based solution that is fully controlled by Microsoft;
                  Microsoft hosts the AI models in Microsoft’s cloud environment
                  and User Data is therefore processed by Microsoft and any sub
                  suppliers utilized by Microsoft. You acknowledge that
                  Microsoft and its suppliers processes User Data contained in
                  Your Prompts and generated content in accordance with the
                  terms and conditions of Microsoft, as updated from time to
                  time.
                </li>
                <li>
                  To utilize CIMATRON AI COPILOT certain personal data about the
                  users will be recorded and processed. The data processing
                  agreement in Schedule A.1 (the “DPA”) applies between CIMATRON
                  and You in relation to processing of personal data regarding
                  Your users. Additionally, to the extent that CIMATRON
                  determines the purposes and means of the personal data
                  processing, such as when we are developing CIMATRON AI
                  COPILOT, CIMATRON becomes the controller for such processing
                  and is, consequently, solely responsible for the lawfulness of
                  such processing as controller under Applicable Data Protection
                  Laws. For information about how CIMATRON process personal
                  data, please refer to Section 2 of the EULA and the{" "}
                  <a
                    href="https://www.cimatron.com/en/about-this-site/privacy/privacy-statement"
                    target="_blank"
                  >
                    Privacy Notice
                  </a>
                  , as updated from time to time. Additionally, for transparency
                  information about how CIMATRON AI COPILOT processes data
                  (including training data, Prompts and Output (as defined
                  below) and the processing of Microsoft) generally, please
                  refer to the <a href="/transparancy-note">Transparency Note</a>, as updated by CIMATRON from
                  time to time. You represent and warrant that you have provided
                  and will provide Your users with the information in the
                  Privacy Note and the Transparency Note, as updated by CIMATRON
                  from time to time, and have obtained and will obtain all
                  required consents and authorizations from your users to enable
                  CIMATRON AI COPILOT to collect, store, process, send, use and
                  disclose User Data as described in the DPA, the Privacy Notice
                  and the Transparency Note, as updated from time to time.
                </li>
              </ul>
              <h4>3. OUTPUTS/COMPLETIONS </h4>
              <hr />
              <p>
                Based on the Prompts, You and Your users may receive
                output/completions from CIMATRON AI COPILOT (“Output”). The
                Output of CIMATRON AI COPILOT is based on the data provided by
                CIMATRON or its affiliates, and the ownership and intellectual
                property rights to the Output and data sources remain with
                CIMATRON or its affiliates.
              </p>
              <p>
                You understand and acknowledge that the Output is not
                customer/user specific and the same Output may be generated by
                CIMATRON AI COPILOT to multiple customers and users of CIMATRON
                AI COPILOT. You receive a license to use the Output that You
                receive from CIMATRON AI COPILOT solely in connection with the
                use of the licensed SOFTWARE and only subject to [that You have
                an active maintenance license to the licensed SOFTWARE and ]
                that You have at all times accepted the latest version of the
                terms and conditions in this Schedule A. You understand and
                acknowledge that the Output received from CIMATRON AI COPILOT
                may not be disclosed by You or Your users to any third party and
                is considered as confidential and proprietary information under
                section 6 (Non-Disclosure) of the End-User License Agreement of
                CIMATRON.
              </p>
              <p>
                You understand that the Output of CIMATRON AI COPILOT is not a
                replacement for Your own judgment and responsibility, and that
                You should utilize human review to check the accuracy and
                completeness of the Output before relying on it as Output may
                include inaccurate, incomplete answers or answers including
                errors. You agree to use CIMATRON AI COPILOT at Your own risk
                and discretion.
              </p>
              <h4>4. LIABILITY DISCLAIMER </h4>
              <hr />
              <p>
                YOU ACKNOWLEDGE THAT THE SERVICES OF CIMATRON AI COPILOT IS
                PROVIDED "AS IS" AND "AS AVAILABLE", WITHOUT ANY WARRANTIES OR
                GUARANTEES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                PARTICULAR PURPOSE, ACCURACY, COMPLETENESS, RELIABILITY,
                SECURITY, OR NON-INFRINGEMENT. YOU ARE SOLELY RESPONSIBLE FOR
                ANY DAMAGES OR LIABILITIES ARISING FROM YOUR USE OF CIMATRON AI
                COPILOT, INCLUDING BUT NOT LIMITED TO ANY HARM TO YOUR SYSTEM,
                DATA LOSS, OR VIOLATION OF THIRD PARTY RIGHTS.
              </p>
              <p>
                YOU AGREE THAT CIMATRON AND ITS AFFILIATES, AND THEIR RESPECTIVE
                OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, LICENSORS, SUPPLIERS,
                AND PARTNERS, ARE NOT LIABLE FOR ANY DIRECT, INDIRECT,
                INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR PUNITIVE
                DAMAGES, OR ANY OTHER DAMAGES OR LOSSES OF ANY KIND, ARISING OUT
                OF OR RELATING TO YOUR USE OF OR INABILITY TO USE CIMATRON AI
                COPILOT, OR ANY DATA OR INFORMATION PROVIDED BY OR OBTAINED FROM
                CIMATRON AI COPILOT, WHETHER BASED ON CONTRACT, TORT,
                NEGLIGENCE, STRICT LIABILITY, OR ANY OTHER LEGAL THEORY, AND
                WHETHER OR NOT CIMATRON AI COPILOT OR ITS AFFILIATES HAVE BEEN
                ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR LOSSES.
              </p>
              <p>
                YOU AGREE TO INDEMNIFY, DEFEND, AND HOLD HARMLESS CIMATRON AND
                ITS AFFILIATES, AND THEIR RESPECTIVE OFFICERS, DIRECTORS,
                EMPLOYEES, AGENTS, LICENSORS, SUPPLIERS, AND PARTNERS, FROM AND
                AGAINST ANY AND ALL CLAIMS, LIABILITIES, DAMAGES, LOSSES, COSTS,
                EXPENSES, OR FEES, INCLUDING REASONABLE ATTORNEYS' FEES, ARISING
                OUT OF OR RELATING TO YOUR USE OF OR INABILITY TO USE CIMATRON
                AI COPILOT, OR ANY DATA OR INFORMATION PROVIDED BY OR OBTAINED
                FROM CIMATRON AI COPILOT, OR ANY VIOLATION OF THIS SCHEDULE A,
                THE AGREEMENT, OR ANY APPLICABLE LAWS OR REGULATIONS BY YOU OR
                ANYONE USING YOUR ACCOUNT OR CREDENTIALS.
              </p>
              <p>
                YOU AGREE THAT YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY
                DISSATISFACTION OR PROBLEM WITH CIMATRON AI COPILOT IS TO STOP
                USING IT AND TO CONTACT CIMATRON OR ITS AFFILIATES FOR SUPPORT
                OR FEEDBACK. FOR THE AVOIDANCE OF ANY DOUBT, CIMATRON IS NOT
                OBLIGATED TO UPDATE, CORRECT ANY ERRORS OR BUGS OR IN ANY WAY
                IMPROVE CIMATRON AI COPILOT AND MAKES NO REPRESENTATION
                WHATSOEVER ABOUT THE QUALITY, AVAILABILITY, SECURITY OR OUTPUT
                OF CIMATRON AI COPILOT.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleA;
